import React from 'react';

import { AuthWrapper, LogoWrapper } from './styled';
import Tips from './tips';

const Layout = ({ children }) => (
  <AuthWrapper>
    <div className="left">
      <LogoWrapper href="/">
        <img src="/static/images/logo/White_small.png" alt="Formplus Logo" />
      </LogoWrapper>

      <Tips />
    </div>

    <div className="right">
      <LogoWrapper className="mobile" href="/">
        <img src="/static/images/logo/Colour_small.png" alt="Formplus Logo" />
      </LogoWrapper>
      
      {children}
    </div>
  </AuthWrapper>
);

export default Layout;